import React, { useState, useRef } from "react";
import { Button, Form, Table } from "react-bootstrap";
import { CustomForm, CustomModal } from "../../components";
import {
  useFetchCollegesQuery,
  useFetchAllSportsQuery,
  useCreateNewsTypeMutation,
  useUpdateNewsTypeMutation,
  useFetchAllNewstypeQuery,
  useDeleteNewsTypeMutation,
} from "../../store/api/apiSlice";
import { toast } from "react-toastify";

import { Button as CustomBtn } from "../../ui";

const baseUrl = process.env.REACT_APP_SERVER_URL;
const secretKey = process.env.REACT_APP_SECRET_KEY;
const NewsLinkManagement = () => {
  const { data: newsDataLink = { news: [] }, refetch } =
    useFetchAllNewstypeQuery();
  const { data: universitiesData } = useFetchCollegesQuery();
  const { data: sportsData } = useFetchAllSportsQuery();
  const sportsList = sportsData?.sports || [];

  const collegeList = universitiesData?.university || [];

  const [tags, setTags] = useState([]);
  const tagsRef = useRef(null);
  const itemsPerPage = 10;
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedConference, setSelectedConference] = useState("");
  const [filteredColleges, setFilteredColleges] = useState([]);
  const [saveButton, setSaveButton] = useState(false);
  const [isModalOpen, setModalOpen] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const [isEditing, setIsEditing] = useState(false);
  const [currentNewsId, setCurrentNewsId] = useState(null);
  const [selectedCollege, setSelectedCollege] = useState(null);
  const [selectedNewsType, setSelectedNewsType] = useState("");
  const [selectedSport, setSelectedSport] = useState("");
  const [selectedGender, setSelectedGender] = useState("");
  const [shortName, setShortName] = useState("");
  const [resourceURL, setResourceURL] = useState("");
  const [sportsRefURL, setSportsRefURL] = useState("");
  const [customID, setCustomId] = useState("");
  const [isViewModalOpen, setViewModalOpen] = useState(false);
  const [viewedNews, setViewedNews] = useState(null);

  const [createNewsType] = useCreateNewsTypeMutation();
  const [updateNewsType] = useUpdateNewsTypeMutation();
  const [deleteNewsType] = useDeleteNewsTypeMutation();
  const handleConferenceChange = (event) => {
    const conference = event.target.value;
    setSelectedConference(conference);

    const filtered = collegeList.filter(
      (college) => college.conference === conference
    );
    setFilteredColleges(filtered);
  };
  const handleCollegeChange = (e) => {
    const collegeName = e.target.value;
    const college = collegeList.find((college) => college.name === collegeName);
    setSelectedCollege(college);
  };
  const handleNewsTypeChange = (e) => setSelectedNewsType(e.target.value);
  const handleSportChange = (e) => setSelectedSport(e.target.value);
  const handleGenderChange = (e) => setSelectedGender(e.target.value);
  const handleShortNameChange = (e) => setShortName(e.target.value);
  const handleResourceURLChange = (e) => setResourceURL(e.target.value);
  const handleSportsRefURLChange = (e) => setSportsRefURL(e.target.value);
  const handleCustomIdChange = (e) => setCustomId(e.target.value);

  const openModal = () => {
    setSaveButton(false);
    setIsEditing(false);
    setModalOpen(true);
  };
  const closeModal = () => {
    setSaveButton(false);
    setModalOpen(false);
    setIsEditing(false);
  };
  const handleInputChange = (e) => {
    setInputValue(e.target.value);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && inputValue.trim()) {
      e.preventDefault();
      addTag(inputValue.trim());
      setInputValue("");
    }
  };

  const addTag = (tag) => {
    if (!tags.includes(tag)) {
      setTags((prevTags) => [...prevTags, tag]);
    }
  };

  const removeTag = (tagToRemove) => {
    setTags((prevTags) => prevTags.filter((tag) => tag !== tagToRemove));
  };
  const paginatedUsers = newsDataLink?.newsTypeLinks?.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );
  const totalPages = Math.ceil(
    newsDataLink?.newsTypeLinks?.length / itemsPerPage
  );
  const handleDelete = async (id) => {
    try {
      await deleteNewsType(id).unwrap();
      toast.success("News deleted successfully");
      refetch();
    } catch (error) {
      toast.error("Error deleting news");
    }
  };
  const handleEdit = (news) => {
    setIsEditing(true);
    setCurrentNewsId(news._id);

    setShortName(news.shortName);
    setSelectedCollege({
      name: news.collegeName,
      _id: news.collegeId,
    });
    setSelectedConference(news.conferenceName);
    console.log({
      name: news.collegeName,
      id: news.collegeId,
    });
    setSelectedNewsType(news.newsType);
    setSelectedSport(news.sportsName);

    setSelectedGender(news.gender);
    setResourceURL(news.resource_URL);
    setSportsRefURL(news.sportsRefURL);
    setTags(news.tags);
    setModalOpen(true);
  };
  const handleSubmit = async (e) => {
    setSaveButton(true);
    e.preventDefault();

    const payload = {
      collegeName: selectedCollege?.name || "",
      collegeId: selectedCollege?._id || "",
      collegeCustomId: 0,
      tags: tags.map((tag) => tag.trim()),
      conferenceName: selectedConference || "",
      shortName: shortName || "",
      newsType: selectedNewsType || "",
      sportsName: selectedSport || "",
      gender: selectedGender || "",
      resource_URL: resourceURL || "",
      sportsRefURL: sportsRefURL || "",
    };

    try {
      if (isEditing) {
        await updateNewsType({ id: currentNewsId, newsData: payload }).unwrap();
        setSaveButton(false);
        toast.success("News updated successfully!");
      } else {
        await createNewsType(payload).unwrap();
        setSaveButton(false);
        toast.success("News created successfully!");
      }
      refetch();
      closeModal();
    } catch (error) {
      setSaveButton(false);
      toast.error("Error saving news");
    }
  };
  const openViewModal = async (id) => {
    const xAuthToken = JSON.parse(localStorage.getItem("token"))?.token || "";
    try {
      const response = await fetch(
        `${baseUrl}/api/news-type-link/get-single/${id}`,
        {
          headers: { "secret-key": secretKey, "x-auth-token": xAuthToken },
        }
      );
      if (response.ok) {
        const data = await response.json();
        setViewedNews(data.newsTypeLink);

        setViewModalOpen(true);
      } else {
        toast.error("Failed to fetch news details.");
      }
    } catch (error) {
      toast.error("An error occurred while fetching news details.");
    }
  };

  const closeViewModal = () => {
    setViewModalOpen(false);
    setViewedNews(null);
  };
  return (
    <div>
      {" "}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginTop: "22px",
        }}
      >
        <h3>News Link Management</h3>
        <Button onClick={openModal}>Create News Link</Button>
      </div>
      <Table striped bordered hover responsive className="mt-4">
        <thead>
          <tr>
            <th>College</th>
            <th>Conference</th>
            <th>College Short Name</th>
            <th>Sport</th>
            <th>News Type</th>
            <th>Gender</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {paginatedUsers?.length > 0 ? (
            paginatedUsers?.map((news) => (
              <tr
                key={news._id}
                style={{ cursor: "pointer" }}
                onClick={() => openViewModal(news._id)}
              >
                <td>{news.collegeName}</td>
                <td>{news.conferenceName}</td>
                <td>{news.shortName}</td>
                <th>{news.sportsName}</th>
                <td>{news.newsType}</td>

                <td>{news.gender}</td>

                <td>
                  <div
                    style={{
                      display: "flex",
                      gap: "5px",
                      justifyContent: "center",
                    }}
                  >
                    <img
                      className="Update-delete-icon"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleEdit(news);
                      }}
                      width="30"
                      height="30"
                      src="https://img.icons8.com/ios-glyphs/30/create-new.png"
                      alt="create-new"
                    />

                    <img
                      className="Update-delete-icon"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleDelete(news._id);
                      }}
                      width="30"
                      height="30"
                      src="https://img.icons8.com/ios-glyphs/30/filled-trash.png"
                      alt="filled-trash"
                    />
                  </div>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="7" className="text-center">
                No data available
              </td>
            </tr>
          )}
        </tbody>
      </Table>
      <div className="d-flex justify-content-center mt-3">
        {Array.from({ length: totalPages }, (_, index) => (
          <Button
            key={index}
            variant={currentPage === index + 1 ? "primary" : "outline-primary"}
            onClick={() => setCurrentPage(index + 1)}
            className="mx-1"
          >
            {index + 1}
          </Button>
        ))}
      </div>
      <CustomModal isOpen={isModalOpen} onClose={closeModal}>
        <div style={{ padding: "1rem", maxHeight: "80vh", overflowY: "auto" }}>
          <h4
            style={{
              fontSize: "1.2rem",
              fontWeight: "bold",
              textAlign: "center",
              marginBottom: "20px",
            }}
          >
            {isEditing ? "Edit News Link" : "Create News Link"}
          </h4>
          <CustomForm onSubmit={handleSubmit}>
            <Form.Group>
              <Form.Label>Conference</Form.Label>
              <Form.Select
                value={selectedConference}
                onChange={handleConferenceChange}
              >
                <option value="">Select Conference</option>
                {collegeList.map((college) => (
                  <option key={college._id} value={college.conference}>
                    {college.conference}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
            <Form.Group>
              <Form.Label>College</Form.Label>
              <Form.Select
                value={selectedCollege?.name || ""}
                onChange={handleCollegeChange}
              >
                <option value="">Select College</option>
                {filteredColleges.map((college) => (
                  <option key={college._id} value={college.name}>
                    {college.name}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
            <Form.Group>
              <Form.Label>College Short Name</Form.Label>
              <Form.Control
                value={shortName}
                onChange={handleShortNameChange}
              />
            </Form.Group>

            <Form.Group>
              <Form.Label>Select News Type</Form.Label>
              <Form.Select
                value={selectedNewsType}
                onChange={handleNewsTypeChange}
                placeholder="News type"
                name="News Type"
              >
                <option value="">Select News Type</option>
                <option value="nil">NIL</option>
                <option value="xfr">TransferPortal</option>
                <option value="recruiting">Recruit</option>
                <option value="General">General</option>
              </Form.Select>
            </Form.Group>

            <Form.Group>
              <Form.Label>Sports</Form.Label>
              <Form.Select value={selectedSport} onChange={handleSportChange}>
                <option value="">Select Sports</option>
                {sportsList.map((sport) => (
                  <option key={sport._id} value={sport.name}>
                    {sport.name}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
            <Form.Group>
              <Form.Label>Select Gender</Form.Label>
              <Form.Select
                value={selectedGender}
                onChange={handleGenderChange}
                placeholder="Gender"
                name="Gender"
              >
                <option value="">Select Gender</option>
                <option value="male">Male</option>
                <option value="female">Female</option>
                <option value="other">Other</option>
              </Form.Select>
            </Form.Group>

            <Form.Group>
              <Form.Label>Resource URL</Form.Label>
              <Form.Control
                value={resourceURL}
                onChange={handleResourceURLChange}
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Sports URL</Form.Label>
              <Form.Control
                value={sportsRefURL}
                onChange={handleSportsRefURLChange}
              />
            </Form.Group>

            <Form.Group className="pb-4" controlId="tags">
              <Form.Label>Tags</Form.Label>
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  border: "1px solid #ccc",
                  borderRadius: "4px",
                }}
              >
                {tags.map((tag, index) => (
                  <span
                    key={index}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      margin: "2px",
                      backgroundColor: "#e0e0e0",
                      borderRadius: "3px",
                    }}
                  >
                    {tag}
                    <button
                      onClick={() => removeTag(tag)}
                      style={{
                        marginLeft: "5px",
                        border: "none",
                        background: "none",
                        cursor: "pointer",
                        color: "#ce1126",
                      }}
                    >
                      x
                    </button>
                  </span>
                ))}
                <input
                  type="text"
                  placeholder="Enter tags"
                  value={inputValue}
                  onChange={handleInputChange}
                  onKeyDown={handleKeyDown}
                  style={{
                    border: "none",
                    outline: "none",
                    flex: "1",
                    minWidth: "100px",
                    padding: "6px 18px",
                  }}
                />
              </div>
            </Form.Group>

            <div className="d-flex justify-content-end mt-3">
              <Button variant="secondary" onClick={closeModal} className="me-2">
                Cancel
              </Button>
              <CustomBtn loading={saveButton} variant="primary" type="submit">
                {isEditing ? "Update" : "Save"}
              </CustomBtn>
            </div>
          </CustomForm>
        </div>
      </CustomModal>
      <CustomModal isOpen={isViewModalOpen} onClose={closeViewModal}>
        <div
          style={{
            maxWidth: "600px",
            padding: "20px",
            maxHeight: "80vh",
            overflowY: "auto",
          }}
        >
          <h3>News Link Details</h3>

          <p>
            <strong>College:</strong> {viewedNews?.collegeName}
          </p>
          <p>
            <strong>Conference:</strong> {viewedNews?.conferenceName}
          </p>
          <p>
            <strong>College Short Name:</strong> {viewedNews?.shortName}
          </p>
          <p>
            <strong>Sport:</strong> {viewedNews?.sportsName}
          </p>
          <p>
            <strong>News Type:</strong> {viewedNews?.newsType}
          </p>
          <p>
            <strong>Gender:</strong> {viewedNews?.gender}
          </p>
          <p>
            <strong>Resource URL:</strong> {viewedNews?.resource_URL}
          </p>
          <p>
            <strong>Sports URL:</strong> {viewedNews?.sportsRefURL}
          </p>

          <p>
            <strong>Tags:</strong>
            {viewedNews?.tags}{" "}
            {viewedNews?.tags && viewedNews.tags.length > 0
              ? (() => {
                  try {
                    const parsedTags = JSON.parse(viewedNews.tags[0]);
                    return parsedTags.join(",");
                  } catch (error) {
                    console.error("Error parsing tags:", error);
                    return viewedNews.tags[0];
                  }
                })()
              : "No tags available"}
          </p>
        </div>
      </CustomModal>
    </div>
  );
};

export default NewsLinkManagement;
